import React from "react";
import { cn } from "@/lib/utils";

export const companies = [
  "Microsoft",
  "Google",
  "Amazon",
  "IBM",
  "Oracle",
  "Salesforce",
  "Cisco",
  "ServiceNow",
  "Adobe",
  "Intel",
];

// Single styled wordmark
export const PartnerLogo = ({ name, className }) => (
  <span
    className={cn(
      "select-none text-xl font-bold tracking-tight text-axor-white/45 transition-colors duration-300 hover:text-axor-white md:text-2xl",
      className,
    )}
    data-testid={`partner-logo-${name.toLowerCase()}`}
  >
    {name}
  </span>
);

// Slow editorial marquee
export const PartnerMarquee = () => (
  <div className="relative w-full overflow-hidden py-2" data-testid="partner-marquee">
    <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-axor-hero to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-axor-hero to-transparent" />
    <div className="flex w-max animate-marquee items-center gap-20">
      {[...companies, ...companies].map((c, i) => (
        <PartnerLogo key={`${c}-${i}`} name={c} />
      ))}
    </div>
  </div>
);

// Static grid — 5x2 desktop, 2-col mobile
export const PartnerLogoGrid = ({ className }) => (
  <div
    className={cn(
      "grid grid-cols-2 gap-x-6 gap-y-8 sm:grid-cols-3 lg:grid-cols-5",
      className,
    )}
    data-testid="partner-grid"
  >
    {companies.map((c) => (
      <div
        key={c}
        className="flex items-center justify-center rounded-2xl border border-white/[0.06] bg-white/[0.02] py-6 transition-colors duration-300 hover:border-axor-cyan/25 hover:bg-white/[0.04]"
      >
        <PartnerLogo name={c} />
      </div>
    ))}
  </div>
);
